var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRingingBellcomponent = function SvgRingingBellcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.25c0-2.303-1.23-4.23-3.375-4.74V3c0-.623-.503-1.125-1.125-1.125-.623 0-1.125.502-1.125 1.125v.51C5.722 4.02 4.5 5.94 4.5 8.25V12L3 13.5v.75h12v-.75L13.5 12V8.25ZM4.612 1.987 5.685 3.06a6.334 6.334 0 0 0-2.663 4.815h-1.5a7.819 7.819 0 0 1 3.09-5.888Zm11.865 5.888h-1.5a6.371 6.371 0 0 0-2.655-4.815l1.066-1.073a7.866 7.866 0 0 1 3.09 5.888ZM9.3 16.47A1.51 1.51 0 0 1 7.493 15h3c0 .21-.038.405-.113.585-.195.45-.593.78-1.08.885Z",
    fill: "current"
  })));
};
export default SvgRingingBellcomponent;